import React from 'react';
import Countdown from 'react-countdown';
import { useLanguage } from '../context/LanguageContext';
import { weddingData } from '../mockData';

const WeddingCountdown = ({ className = "", showTitle = true }) => {
  const { language } = useLanguage();
  const content = weddingData[language].countdown;
  
  // Wedding date: August 14, 2026
  const weddingDate = new Date('2026-08-14T00:00:00');

  const renderer = ({ days, hours, minutes, seconds, completed }) => {
    if (completed) {
      return (
        <div className="text-center py-4">
          <p className="text-xl sm:text-2xl font-playfair font-bold text-gold-600">
            {language === 'fr' ? 'C\'est aujourd\'hui !' : 'It\'s today!'}
          </p>
        </div>
      );
    }

    const timeBlocks = [
      { value: days, label: content.days },
      { value: hours, label: content.hours },
      { value: minutes, label: content.minutes },
      { value: seconds, label: content.seconds }
    ];

    return (
      <div className={`flex items-center justify-center gap-2 xs:gap-3 sm:gap-4 ${className}`}>
        {timeBlocks.map((block, index) => (
          <React.Fragment key={block.label}>
            {/* Time Block */}
            <div className="text-center group">
              <div 
                className="relative bg-white/95 backdrop-blur-lg border-2 border-lilac-200 rounded-xl sm:rounded-2xl 
                           p-2 xs:p-3 sm:p-4 min-w-[52px] xs:min-w-[60px] sm:min-w-[80px] md:min-w-[90px]
                           hover:border-gold-400 hover:scale-105 transition-all duration-300
                           shadow-soft hover:shadow-gold"
              >
                {/* Number */}
                <div 
                  className="text-2xl xs:text-3xl sm:text-4xl md:text-5xl font-playfair font-bold text-plum-900 
                             leading-none mb-1"
                >
                  {String(block.value).padStart(2, '0')}
                </div>
                {/* Label */}
                <div 
                  className="text-[9px] xs:text-[10px] sm:text-xs font-montserrat text-plum-600 
                             uppercase tracking-wider font-semibold"
                >
                  {block.label}
                </div>
              </div>
            </div>

            {/* Separator */}
            {index < timeBlocks.length - 1 && (
              <div className="text-lg xs:text-xl sm:text-2xl md:text-3xl text-gold-500 font-bold self-center pb-4">
                :
              </div>
            )}
          </React.Fragment>
        ))}
      </div>
    );
  };

  return (
    <div className="w-full">
      {showTitle && (
        <p className="text-sm sm:text-base md:text-lg font-montserrat text-plum-700 mb-4 sm:mb-6 text-center font-medium">
          {content.title}
        </p>
      )}
      <Countdown date={weddingDate} renderer={renderer} />
    </div>
  );
};

export default WeddingCountdown;
